import { c as _c } from "react/compiler-runtime";
import type { CartItemOutputDto } from "@sticker-giant/sg-frontend-common";
import { IconCircleCheck } from "@tabler/icons-react";
interface Props {
  item: CartItemOutputDto;
}
export function ReorderBadge(t0) {
  const $ = _c(1);
  const {
    item
  } = t0;
  if (!item.isReorder) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex items-center gap-1 text-green-600 pt-1"><IconCircleCheck size={16} /><span>Reorder</span></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  return t1;
}